export default __webpack_public_path__ + "assets/images/d24d0083aea61843d37ffac902a265c7.png";